// Vite does not include `global` like webpack, and this is required for "zxcvbn-async"
window.global ||= window;
